import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

// Components

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// PropTypes
export const propTypes = {
  label: PropTypes.string,
  isSelected: PropTypes.bool,
}

// DefaultProps
export const defaultProps = {
  isSelected: false,
}

function Option(props) {
  const { label, isSelected } = props

  return (
    <div className={cx('option')} data-is-selected={isSelected}>
      {label}
    </div>
  )
}

Option.propTypes = propTypes
Option.defaultProps = defaultProps

export default Option
